<template>
  <div id="container">
    <!-- <div class='pdf-page'> -->
    <div :style="{'width':width+'px','height':height+'px'}" id="warped">
      <canvas id="the-canvas"></canvas>
    </div>
    <div class="foot" v-if='pdfDoc'>
      <button @click="onPrevPage" class='left' v-if="pageNum>1">上一页</button>
      <button @click="onNextPage" class='right' v-if="pageNum<pdfDoc.numPages">下一页</button>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
  import PDFJS from 'pdfjs-dist'

  export default {
    data() {
      return {
        pdfDoc: null,
        pageNum: 1,
        pageRendering: false,
        pageNumPending: null,
        scale: 0.9,
        width: null,
        height: null,
      }
    },
    components: {},
    mounted() {
      this.showPDF()
    },
    methods: {
      showPDF() {
        const _this = this
        PDFJS.getDocument('../../../static/pdf/user_help.pdf').then(function (pdf) {
          _this.pdfDoc = pdf;
          _this.renderPage(1)
        })
      },
      renderPage(num) {
        this.pageRendering = true;
        const _this = this
        this.pdfDoc.getPage(num).then(function (page) {
          //var viewport = page.getViewport(screen.availWidth / page.getViewport(1).width)
          const viewport = page.getViewport(2)
          let canvas = document.getElementById('the-canvas');
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          _this.width = viewport.width / 2;
          _this.height = viewport.height / 2;
          // Render PDF page into canvas context
          const renderContext = {
            canvasContext: canvas.getContext('2d'),
            viewport: viewport
          }
          const renderTask = page.render(renderContext)

          // Wait for rendering to finish
          renderTask.promise.then(function () {
            _this.pageRendering = false;
            if (_this.pageNumPending !== null) {
              // New page rendering is pending
              this.renderPage(_this.pageNumPending);
              _this.pageNumPending = null
            }
          })
        })
      },
      queueRenderPage(num) {
        if (this.pageRendering) {
          this.pageNumPending = num
        } else {
          this.renderPage(num)
        }
      },
      onPrevPage() {
        if (this.pageNum <= 1) {
          return
        }
        this.pageNum--;
        this.queueRenderPage(this.pageNum)
      },
      onNextPage() {
        if (this.pageNum >= this.pdfDoc.numPages) {
          return
        }
        this.pageNum++;
        this.queueRenderPage(this.pageNum)
      }
    }
  }
</script>

<style scoped>
  #container {
    background-color: #fff;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    text-align: center;
    overflow: hidden;
  }

  #the-canvas {
    transform: translate(-25%, -25%) scale(0.5);
  }

  .pdf-page {

  }

  #warped {
    overflow: hidden;
    margin: 0 auto;
  }

  .foot {
    height: 0.8rem;
    line-height: 0.8rem;
  }

  .foot button {
    border: none;
    width: 1.2rem;
    height: 0.4rem;
    background-color: #3e3e3e;
    color: #fff;
    outline: none;
    vertical-align: middle;
    line-height: 0.4rem;
    border-radius: 0.5rem;

  }
</style>



// WEBPACK FOOTER //
// src/components/content/pdf/pdf.vue